import { Position } from '@statsbomb/parachute-types';
import { Atom } from 'jotai';
import { Loadable } from '@/utils/jotai';
import { Nullable, NumberOption } from './generic';
import { MetricDefinition } from './metric';

export interface RadarTemplate {
  id: string;
  positions?: Position[] | null;
  titleSettings: {
    title: string;
    translate: boolean;
  };
  metrics: {
    key: string;
    keyNormalised: string;
    min: number;
    max: number;
    default: boolean;
  }[];
}

export type SelectedGamesAtom = Atom<Loadable<Promise<NumberOption[]>>>;

export interface RadarData extends MetricDefinition {
  minValue: number;
  maxValue: number;
  decimalPlaces: number;
  value: number;
  // false when the metric has no underlying data. `value` is still populated with the template
  // minimum so the chart has a plottable spoke; the table reads this flag to render n/a instead.
  hasValue: boolean;
}

export type LoadableRadarDataAtom = Atom<Loadable<Promise<Nullable<RadarData[]>>>>;

export type ComparisonRadarDataAtom = Atom<{ data: RadarData[]; isLoading: boolean }>;

export type LimitMode = 'default' | 'custom';

export enum RadarDataFormat {
  Per90 = 'per90',
  Percentiles = 'percentiles',
}
